/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import locale from './locale'
import Form from 'components/Form';
import getStudentCustomFields from 'controllers/student/getStudentCustomFields';
import CheckboxForCustomField from 'components/UI/CustomField/CheckboxForCustomField';

class ModalContent extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      customFieldSchema: [],
    }
  }

  componentWillMount(){
    this.loadCustomFieldSchema();
  }

  loadCustomFieldSchema() {
    const schoolId = localStorage.getItem('schoolId');
    getStudentCustomFields(schoolId)
      .then((res)=>{
        if (res && res.student_fields_setting) {
          const { fields } = res.student_fields_setting;
          const customFieldSchema = [];

          fields.map((field, index) => {
            const {
              id,
              label,
              type,
              options,
              required,
            } = field

            if (typeof label === 'string' && label.length > 0) {
              switch (type) {
              case "text":
                customFieldSchema.push({name: id, label: label, type: 'text', required})
                break;
              case "select":
                let optionArr = options.map((option, i) => {
                  return {
                    value: option,
                    label: option,
                  }
                })

                // add an empty value in the beginning
                optionArr = [ {}, ...optionArr ];

                customFieldSchema.push({
                  name: id,
                  required,
                  label,
                  type: 'select',
                  options: optionArr,
                });

                break;
              case "checkbox":
                customFieldSchema.push({
                  name: id,
                  label:
                  label,
                  type: 'custom',
                  required,
                  component: (value, onChange, item, props)=>{
                    return <CheckboxForCustomField value={value} onChange={onChange} item={field} />
                  }
                })
                break;
              }
            }
          });

          this.setState({
            customFieldSchema,
          });

        }
    })
    .catch((err)=>{console.error(err)});


  }

  render() {

    const formSchema = [
      {
        name: 'name',
        label: __('Student Name', locale),
        type: 'name',
        required: true,
      },
      {
        name: 'gender',
        label: __('Gender', locale),
        type: 'gender',
        required: true,
      },
      {
        name: 'phoneParsed',
        label: __('Phone', locale),
        type: 'phone',
        required: false,
        tip: __('Student can use phone number to sign up and log in mobile app', locale)
      },
      {
        name: 'photo',
        label: __('Student Photo', locale),
        type: 'imageUploader',
        options: {
          aspectRatioHeight: 1,
          aspectRatioWidth: 1,
        }
      },
      {
        name: 'dob',
        label: __('DOB', locale),
        type: 'datePicker',
      },
      {
        name: 'email',
        label: __('Email', locale),
        type: 'email'
      },
      {
        name: 'nickName',
        label: __('Preferred Name', locale),
        type: 'text'
      },
      {
        name: 'createdOn',
        label: __('Created On', locale),
        type: 'datePicker'
      },
      {
        name: 'address',
        label: __('Address', locale),
        type: 'address'
      },
      {
        name: 'remark',
        label: __('Remarks', locale),
        type: 'textarea'
      },
      {
        name: 'primaryGuardian',
        label: __('Primary Guardian', locale),
        type: 'guardian'
      },
      {
        name: 'secondaryGuardian',
        label: __('Secondary Guardian', locale),
        type: 'guardian'
      },
    ];

    const {
      formData,
      onFormChange,

      customFormData,
      onCustomDataChange,

      scrollingContainerRef,
    } = this.props;

    const {
      customFieldSchema,
      fields
    } = this.state;

    return (
      <div className='create-student-modal-content'>
        <h3>{__('Basic Info', locale)}</h3>
        <Form
          onChange={onFormChange}
          schema={formSchema}
          formData={formData}
          formStyle='inline'
          getValidationRef={this.props.getValidationRef}
          scrollingContainerRef={scrollingContainerRef}
        />
        <h3>{__('Other Info', locale)}</h3>
        <Form
          onChange={onCustomDataChange}
          schema={customFieldSchema}
          formData={customFormData}
          formStyle='inline'
          getValidationRef={this.props.getCustomDataValidationRef}
          scrollingContainerRef={scrollingContainerRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/CreateStudent/ModalContent.js